import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { LsSingleSelectComponent } from '../ls-single-select.component';

@Component({
  selector: 'ls-single-tooltip-select',
  templateUrl: './ls-single-tooltip-select.component.html',
  styleUrls: ['./ls-single-tooltip-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LsSingleTooltipSelectComponent),
      multi: true
    }
  ]
})
export class LsSingleTooltipSelectComponent extends LsSingleSelectComponent {
  @Input()
  public minWidth = 0;

  constructor() {
    super();
  }
}
